import React, { useEffect, useRef } from 'react';
import RichText, { RichTextProps } from '../RichText/RichText';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

import {
  AnimationVariants,
  getAnimationVariants,
} from '../../../../helpers/animations';
import { SectionElementAnimatedContainer } from './styles/SectionElementAnimated.styles';

type SectionElementAnimatedProps = {
  animation: AnimationVariants;
  content: RichTextProps[];
  isLooped?: boolean;
  isPlaying: boolean;
};

gsap.registerPlugin(useGSAP);

const ANIMATION_DURATION = 1.5;
const DELAY = 3;

const SectionElementAnimated: React.FC<SectionElementAnimatedProps> = ({
  isLooped,
  isPlaying,
  content,
  animation,
}) => {
  const container = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      const gsapAnimation = gsap.timeline({ repeat: isLooped ? -1 : 0 });
      const numberOfTargets = content.length;
      const stagger = ANIMATION_DURATION + DELAY;

      const animationVariant = getAnimationVariants(animation, {
        animationDuration: ANIMATION_DURATION,
        delay: DELAY,
        numberOfTargets,
        isLooped,
      });

      if (!animationVariant) {
        return;
      }

      gsap.set('.animated-content', { opacity: '1' });

      gsapAnimation
        .from('.animated-content', animationVariant.from)
        .to('.animated-content', animationVariant.to, stagger);
    },
    { scope: container }
  );

  useEffect(() => {
    if (!isPlaying) {
      gsap.globalTimeline.pause();
    } else {
      gsap.globalTimeline.resume();
    }
  }, [isPlaying]);

  return (
    <SectionElementAnimatedContainer ref={container}>
      {content.map(item => {
        return (
          <div className="animated-content" key={item.id}>
            <RichText {...item} />
          </div>
        );
      })}
    </SectionElementAnimatedContainer>
  );
};

export default SectionElementAnimated;
